export const initAction = 'initAction';
export const setDefaultTimezoneAction = 'setDefaultTimezoneAction';
export const initIntercomForUserAction = 'initIntercomForUserAction';
export const showIntercomAction = 'showIntercomAction';
export const updateIntercomAction = 'updateIntercomAction';
export const shutdownIntercomAction = 'shutdownIntercomAction';
